import { render, staticRenderFns } from "./ForEmployersMainSection.vue?vue&type=template&id=e6a57dca&"
import script from "./ForEmployersMainSection.vue?vue&type=script&lang=js&"
export * from "./ForEmployersMainSection.vue?vue&type=script&lang=js&"
import style0 from "./ForEmployersMainSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports